import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  // root: {
  //   width: '100%',
  //   // maxWidth: 360,
  //   // backgroundColor: theme.palette.background.paper,
  //   position: 'relative',
  //   height: '500px'
  // },
  // container: {
  //   position: 'absolute',
  //   top: '10px',
  //   right: '100px',
  //   overflowY: 'scroll'

  // }
})

const uniquify = features => {
  let stripIds = {}
  const strips = features.filter(feature => {

    if (stripIds[feature.properties.strip_id]) {
      return false
    }
    stripIds[feature.properties.strip_id] = true
    return true
  })

  return strips
}

const uniquifyGeneral = features => {
  let uniqueIds = {}
  const strips = features.filter(feature => {
    const { acquired, item_type } = feature.properties
    const date = acquired.split('T')[0]
    const id = `${item_type}-${date}}`
    if (uniqueIds[id]) {
      return false
    }
    uniqueIds[id] = true
    return true
  })

  return strips
}

class PlanetList extends Component {
  render () {
    const { classes, features, onClick } = this.props

    if (!features || features.length === 0) {
      return null
    }

    const strips = uniquifyGeneral(features)
    return (
      <div className={classes.container} >
        <List className={classes.root} >
          {strips.map((feature, index) => {
            const { acquired, item_type } = feature.properties
          return (
            <ListItem
              button
              onClick={() => onClick(feature)}
              >
              <ListItemText primary={item_type} secondary={acquired} />
            </ListItem>
          )
})}
</List>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { slice = 'planet' } = ownProps
  return {
    features: state[slice].features
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(PlanetList))



// WEBPACK FOOTER //
// ./src/components/PlanetList.js